import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/stepwise/stepwise.less';

/**
 * Вспомогательный компонент для [Stepwise](#stepwise), рендерит один шаг.
 */
export default function StepwiseStep({
    title,
    info,
    infoNoWrap,
    done,
    current,
    link,
    iconOnly,
    Element,
    ...stepwiseStepProps
}) {
    return (
        <Element
            className={classnames('bloko-stepwise-step', {
                'bloko-stepwise-step_done': done,
                'bloko-stepwise-step_current': current,
                'bloko-stepwise-step_link': link,
                'bloko-stepwise-step_icon-only': iconOnly,
            })}
            {...stepwiseStepProps}
        >
            {title && <span className="bloko-stepwise-step__title">{title}</span>}
            {info && (
                <span
                    className={classnames('bloko-stepwise-step__info', {
                        'bloko-stepwise-step__info_nowrap': infoNoWrap,
                    })}
                >
                    {info}
                </span>
            )}
        </Element>
    );
}

StepwiseStep.propTypes = {
    /** Заголовок */
    title: PropTypes.string,
    /** Текст под заголовком */
    info: PropTypes.string,
    /** Запрет переноса текста */
    infoNoWrap: PropTypes.bool,
    /** Завершенный шаг */
    done: PropTypes.bool,
    /** Текущий шаг */
    current: PropTypes.bool,
    /** Шаг в виде ссылки, реагирует на наведение */
    link: PropTypes.bool,
    /** Только с иконкой */
    iconOnly: PropTypes.bool,
    /** Кастомный компонент функция или 'span', 'a' */
    Element: componentInvariants(['span', 'a']),
};

StepwiseStep.defaultProps = {
    infoNoWrap: false,
    done: false,
    current: false,
    link: false,
    iconOnly: false,
    Element: 'span',
};
